import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { SaveChanges } from 'components/SaveChanges'
import { useEffect, useState } from 'react'
import { getAdminConfig, setAdminConfig } from 'services'
import { RenderInput } from 'utils/RenderInput'

import { getLinkConfigurationFields } from './constants'

export const Links = () => {
  const [data, setData] = useState<Record<string, any>>({})
  const [isLoading, setLoading] = useState(false)
  const [changed, setChanged] = useState(false)

  const inputs = getLinkConfigurationFields()

  useEffect(() => {
    setLoading(true)
    getAdminConfig('linkConfig')
      .then((value) => {
        setData(value)
      })
      .finally(() => setLoading(false))
  }, [])

  const onChange = (key: string, value: any) => {
    const temp = cloneDeep(data)
    temp[key] = value
    setData(temp)
    setChanged(true)
  }

  const onSubmit = async () => {
    setLoading(true)
    await setAdminConfig('linkConfig', data)
    setLoading(false)
    setChanged(false)
  }

  return (
    <div className="relative">
      <LayoutLoading show={isLoading} />

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2">
        {Object.keys(inputs).map((key, index) => {
          const input = inputs[key]
          input.value = data[key]

          if (key === 'instructionAssetVerification') {
            input.additionalElements = (
              <input
                className="border-gray-300 border-[1px] px-1 w-[300px]"
                value={data.assetVerificationLinkTitle}
                onChange={(e: any) => onChange('assetVerificationLinkTitle', e.target.value)}
              />
            )
          }

          return (
            <div className={`input md:col-span-${input.span || 1} `} key={index}>
              <RenderInput Key={key} input={input} onChange={(key: string, value: string) => onChange(key, value)} />
            </div>
          )
        })}
      </div>
      <SaveChanges show={changed} label="Save Changes" onSave={onSubmit} />
    </div>
  )
}
